module.exports = __webpack_public_path__ + "static/media/dec-1.0023a885.jpeg";